/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * DDEX rights controller
 * @export
 * @interface DdexRightsController
 */
export interface DdexRightsController {
    /**
     * 
     * @type {string}
     * @memberof DdexRightsController
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DdexRightsController
     */
    roles: Array<string>;
    /**
     * Optional
     * @type {string}
     * @memberof DdexRightsController
     */
    rightsShareUnknown?: string;
}

/**
 * Check if a given object implements the DdexRightsController interface.
 */
export function instanceOfDdexRightsController(value: object): value is DdexRightsController {
    let isInstance = true;
    isInstance = isInstance && "name" in value && value["name"] !== undefined;
    isInstance = isInstance && "roles" in value && value["roles"] !== undefined;

    return isInstance;
}

export function DdexRightsControllerFromJSON(json: any): DdexRightsController {
    return DdexRightsControllerFromJSONTyped(json, false);
}

export function DdexRightsControllerFromJSONTyped(json: any, ignoreDiscriminator: boolean): DdexRightsController {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'roles': json['roles'],
        'rightsShareUnknown': !exists(json, 'rights_share_unknown') ? undefined : json['rights_share_unknown'],
    };
}

export function DdexRightsControllerToJSON(value?: DdexRightsController | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'roles': value.roles,
        'rights_share_unknown': value.rightsShareUnknown,
    };
}

